export default {"src":"/org/_next/static/media/people.884ad5bc.svg","height":10,"width":13,"blurWidth":0,"blurHeight":0};